module.exports = __webpack_public_path__ + "img/club_olimpia.7ff0bb34.png";